import { useVersion } from '@shared/config'

export default defineNuxtPlugin(() => {
  const versionInfo = useVersion()
  
  // Проверяем, не в iframe ли мы (для предотвращения дублирования в админке)
  const isInIframe = window.self !== window.top
  
  if (!isInIframe && // Добавляем информацию о версии в глобальный объект для отладки
    typeof window !== 'undefined') {
      (window as any).APP_VERSION = {
        version: versionInfo.version,
        buildNumber: versionInfo.buildNumber,
        buildTime: versionInfo.buildTime,
        gitCommit: versionInfo.gitCommit,
        environment: versionInfo.environment,
        buildTimestamp: versionInfo.buildTimestamp,
      }
    }
}) 